const isDev = process.env.REACT_APP_ENV_FILE_NAME === 'dev';
const localApiOrigin = process.env.REACT_APP_API_ORIGIN || 'http://localhost:4000';

export const API_BASE = isDev
  ? `${localApiOrigin}/api/v1`
  : 'https://api.atoplatform.com/api/v1';
export const API_URL = isDev ? localApiOrigin : 'https://api.atoplatform.com';